import { Box, Text } from "@chakra-ui/react";
import {
  Release,
  ReleasePricingInfo,
  ReleasePricingType,
} from "../../../types";
import { useReleasePricingInfo } from "../../../hooks/useReleasePricingInfo";

export interface SaleBadgeProps {
  release?: Release;
  discountPercentage?: number;
  releasePricingInfo?: ReleasePricingInfo;
  showInCorner?: boolean;
}

export function SaleBadge({
  release,
  discountPercentage,
  releasePricingInfo,
  showInCorner = true,
}: SaleBadgeProps) {
  const pricingInfo = useReleasePricingInfo(release);
  const discount =
    discountPercentage ??
    calculateDiscountPercentage(releasePricingInfo ?? pricingInfo);

  if (!discount || discount <= 0) {
    return null;
  }

  return (
    <Box
      position={showInCorner ? "absolute" : "relative"}
      width="fit-content"
      bg="success.700"
      padding="4px 8px"
      borderRadius={showInCorner ? "10px 0 5px 0" : "5px"}
      zIndex={2}
      backdropFilter="blur(2.5px)"
      top={showInCorner ? "0" : "auto"}
      left={showInCorner ? "0" : "auto"}
    >
      <Text
        fontSize="12px"
        fontWeight="700"
        lineHeight="150%"
        textTransform="uppercase"
        color="neutral.white"
      >
        SAVE {discount}%
      </Text>
    </Box>
  );
}

function calculateDiscountPercentage(
  pricingInfo: ReleasePricingInfo,
): number | null {
  const { type, regularPrice, salePrice, goldSalePrice } = pricingInfo;

  switch (type) {
    case ReleasePricingType.OnSale:
    case ReleasePricingType.OnSaleWithGoldDiscount:
    case ReleasePricingType.OnSaleAndAvailableGoldDiscount:
    case ReleasePricingType.OnSaleOrFreeWithGold:
    case ReleasePricingType.onSaleWithAvailableOnGoldSale:
      if (regularPrice && salePrice && regularPrice > salePrice) {
        return Math.round(((regularPrice - salePrice) / regularPrice) * 100);
      }
      break;

    case ReleasePricingType.OnGoldSale:
      if (regularPrice && goldSalePrice && regularPrice > goldSalePrice) {
        return Math.round(
          ((regularPrice - goldSalePrice) / regularPrice) * 100,
        );
      }
      break;

    default:
      return null;
  }

  return null;
}
